<template>
   <atom-text :key="error" v-bind="$props" size="x-small" class="ml-1" color="danger">
      <!-- &#8226;  -->
      &#10071; {{ error }}
   </atom-text>
</template>

<script>
import AtomText from '../../../atoms/Login/Text';

export default {
   name: 'error-text',
   components: {
      AtomText,
   },
   props: {
      error: {
         type: String,
         required: true,
      }
   },

}
</script>